import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    if (!show) return null;
    return (
        <button
            type="button"
            aria-label="Scroll back to top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="hidden md:inline-flex fixed bottom-6 left-6 z-30 items-center justify-center w-11 h-11 bg-cs-navy text-white border border-cs-navy hover:bg-cs-orange hover:border-cs-orange transition-colors"
            data-testid="back-to-top-btn"
        >
            <ArrowUp size={18} strokeWidth={2} />
        </button>
    );
}
